/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the various statuses that a specimen can have during its lifecycle.
 */
export enum SpecimenStatus {
    CREATED = 'created',
    HARVESTED = 'harvested',
    SENT_TO_LABORATORY = 'sentToLaboratory',
    RECEIVED = 'received',
    IN_PROGRESS = 'inProgress',
    REJECTED = 'rejected',
    COMPLETED = 'completed',
}
